import { ArcLayer } from '@deck.gl/layers';
const defaultProps = {
    getHeight: { type: 'accessor', value: 0 },
    greatCircle: true
};
// This layer has been merged into the core ArcLayer
// Keeping for backward-compatibility
/** @deprecated Use ArcLayer with `greatCircle: true` instead */
export default class GreatCircleLayer extends ArcLayer {
    static { this.layerName = 'GreatCircleLayer'; }
    static { this.defaultProps = defaultProps; }
}
